import type { TypewriterScenario } from '../scenario'

import enterpriseSales from './enterprise-sales.json'
import finance from './finance.json'
import media from './media.json'
import retail from './retail.json'
import saas from './saas.json'

const scenarios = {
  'enterprise-sales': enterpriseSales as unknown as TypewriterScenario,
  finance: finance as unknown as TypewriterScenario,
  media: media as unknown as TypewriterScenario,
  retail: retail as unknown as TypewriterScenario,
  saas: saas as unknown as TypewriterScenario,
} as const

export const getTypewriterScenario = (scenarioId?: string | null) =>
  scenarioId ? scenarios[scenarioId as keyof typeof scenarios] : undefined
